<template>
  <div class="">
    <v-header ref="dudu"></v-header>
    <div class="beijngsd">
      <span></span>
      个人中心
      <span></span>
    </div>
    <div class="manpin">
      <div class="main centen container">
        <leftmenu ref="leftmenu"></leftmenu>
        <!-- 在class为main_r里面写页面就行 -->
        <div class="main_r">
          <div class="mainr_top" v-if="userInfo.userRole == '2'||userInfo.userRole == '3'">
            <img src="../images/geren16.png">我的志愿
            <div class="serachkuang" style="margin-left: 100px;">
              <el-select class="searchsel" filterable v-model="selectId" @change="search">
                <el-option value="">全部学生</el-option>
                <el-option v-for="u in userList" :value="u.userId" :key="u.userId" :label="u.userName"></el-option>
              </el-select>
              <input placeholder="请输入查询的志愿单" class="sinput" v-model="zydname" @keydown.enter="search"></input>
              <div class="sousuo" @click="search">
                查询
              </div>
            </div>
          </div>
          <el-pagination style="margin-top: 10px;" background layout="prev, pager, next,total" prev-text="上一页"
            next-text="下一页" @current-change="changePage" :current-page="pageNum" :page-size="pageSize" :total="total"
            v-if="userInfo.userRole == '2'||userInfo.userRole == '3'">
          </el-pagination>

          <!--我的志愿-->
          <ul class="zhiyuanList">
            <li v-for="(item,index) in data">
              <div class="ranking" :class="getrankcss(item.volunteerRate)">{{index+1<10?'0'+(index+1):(index+1)}}</div>
              <div class="itemLeft flex-items">
                <div class="assess">
                  <span :style="$utils.getrateStyle(item.volunteerRate)">{{item.volunteerRate}}</span>
                  <h5 :style="$utils.getrateStyle(item.volunteerRate)">评估得分</h5>
                </div>
                <em></em>
                <div class="txt" style="min-width: 250px;">
                  <h4>{{item.volunteerName}} <img style="margin-left: 10px;width: 14px;height: 14px;"
                      src="../../../src/assets/img/bianji.png" alt="" @click="updateName(item.volunteerId)"></h4>
                  <div class="flex-items">
                    <div class="sheng"><b style="color: #F53824;">{{item.spare3}}</b></div>
                    <div class="sheng">{{AREA_OBJ[item.spare]}}</div>
                    <div class="ke" v-if="xuankeArea.xingaokao.indexOf(AREA_OBJ[item.spare])!=-1">
                      {{item.volunteerXuanke}}
                    </div>
                  </div>
                </div>
                <div class="list">
                  <dl class="flex-items">
                    <dt>成绩：</dt>
                    <dd>{{item.volunteerScore}}分</dd>
                  </dl>
                  <dl class="flex-items">
                    <dt>科目：</dt>
                    <dd>{{SUBJECTTYPEOBJ[item.volunteerSubject]}}</dd>
                  </dl>
                  <dl class="flex-items">
                    <dt>批次：</dt>
                    <dd>{{item.volunteerBatch}}</dd>
                  </dl>
                </div>
                <div class="list">
                  <dl class="flex-items">
                    <dt>志愿数：</dt>
                    <dd>{{item.volunteerNum}}</dd>
                  </dl>
                  <dl class="flex-items">
                    <dt>院校数：</dt>
                    <dd>{{item.volunteerCollege}}</dd>
                  </dl>
                  <dl class="flex-items">
                    <dt>专业数：</dt>
                    <dd>{{item.volunteerMajor}}</dd>
                  </dl>
                </div>
              </div>
              <div class="itemRigth">
                <div class="btns">
                  <a class="xq" @click="zhongdian(item)">查看</a>
                  <a class="del" @click="del(index)">删除</a>
                </div>
                <time><span>创建时间：</span>{{item.creatTime}}</time>
              </div>
            </li>
          </ul>
          <el-pagination background layout="prev, pager, next,total,jumper" prev-text="上一页" next-text="下一页"
            @current-change="changePage" :current-page="pageNum" :page-size="pageSize" :total="total"
            v-if="userInfo.userRole == '2'||userInfo.userRole == '3'">
          </el-pagination>
        </div>
      </div>
    </div>
    <item7></item7>
    <toast :title="title" :message="message" v-if="toastflag" @close="toastflag = false" :flag="toastflag"
      @quxiao="toastflag=false" :fun="fun" @del="batchDelet" btn="que,qu"></toast>



    <div class="tuichuden" v-if="show">
      <div class="annou" style="width: 450px;">
        <h1>修改志愿单名称</h1>
        <div>
          <ul class="form">
            <li>
              <label style="width: 50px;">名称：</label>
              <div class="shoujiinp">
                <input style="width: 220px;" v-model="vName" placeholder="请输入新名称" @focus="error=''" />
                <span class="shangxia" style="margin-top: 10px;" v-if="error!=null&&error!=''">{{error}}</span>
              </div>
            </li>
          </ul>
        </div>
        <dl class="two">
          <dt @click="quxiao">取消</dt>
          <dd @click="quit">确认</dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
  import vHeader from '../../components/vHeader.vue'
  import item7 from '../../components/item7.vue'
  import leftmenu from '../../components/leftmenu.vue'
  import toast from '../../components/toast.vue'
  export default {
    name: "",
    components: {
      vHeader,
      item7,
      leftmenu,
      toast
    },
    data() {
      return {
        total: 0,
        zydname: "",
        selectId: "",
        pageSize: 10,
        pageNum: 1,
        show: false,
        error: "",
        vid: "",
        vName: "",
        data: [],
        userList: [],
        AREA_OBJ: {},
        areaInfo: {},
        SUBJECTTYPEOBJ: {},
        title: "",
        message: "",
        toastflag: false,
        fun: '',
        index: -1,
        xuankeArea: this.$utils.getlocalStorage("xuankeArea"),
        userInfo:this.$utils.getlocalStorage("userInfo")
      }
    },
    created() {
      console.log(this.$utils.getlocalStorage("zyd_selectId"))
      if (this.$route.params.id != null) {
        this.selectId = this.$route.params.id
      } else if (this.$utils.getlocalStorage("zyd_selectId") != null&&this.$utils.getlocalStorage("zyd_selectId") != '') {
        let obj =  JSON.parse(this.$utils.getlocalStorage("zyd_selectId"))
        this.selectId = obj.selectId;
        this.pageNum = obj.pageNum;
        this.zydname = obj.zydname;
      } else if(this.selectId == ''){
        //this.selectId = this.$utils.getlocalStorage("userInfo").userId
      }
      console.log('grzx_wodezhiyuan')
      this.AREA_OBJ = this.$utils.getlocalStorage("AREA_OBJ")
      this.areaInfo = this.$utils.getlocalStorage("areaInfo")
      this.SUBJECTTYPEOBJ = this.$utils.getlocalStorage("SUBJECTTYPEOBJ")
      this.getData()
      this.getUserList();
    },

    methods: {
      del(index) {
        this.index = index;
        this.title = "温馨提示"
        this.message = "您确认删除该志愿单？"
        this.fun = "del"
        this.toastflag = true;
      },
      zhongdian(item) {
        this.$utils.setlocalStorage("zyd_selectId", JSON.stringify({
          selectId: this.selectId,
          pageNum: this.pageNum,
          zydname:this.zydname
        }))
        this.$utils.setlocalStorage("volunteerTableInfo", item)
        // this.$router.push('/grzx_yhzybgd_lao')
        let routeUrl = this.$router.resolve({
             path: "/grzx_yhzybgd_lao",
           });
         window.open(routeUrl.href,'_blank')

      },
      search() {
        this.pageNum = 1
        this.getData()
      },
      changePage(page) {
        this.pageNum = page
        this.getData()
      },
      getrankcss(rate) {
        let type = 'btj'
        if (rate < this.$fxg) {
          return {
            rankingbtj: true
          }
        } else if (rate >= this.$fxg && rate <= this.$cyc) {
          return {
            rankingcyc: true
          }
        } else if (rate > this.$cyc && rate <= this.$wyw) {
          return {
            rankingwyw: true
          }
        } else if (rate > this.$wyw && rate <= this.$byb) {
          return {
            rankingbyb: true
          }
        } else if (rate > this.$byb) {
          return {
            rankingdyd: true
          }
        }
      },
      getData() {
        console.log(this.zydname)
        let _this = this;
        let queryObj = {};
        if (this.selectId != null && this.selectId != "") {
          queryObj.spare2 = this.selectId;
        }

        if (this.zydname != null && this.zydname != "") {
          queryObj.volunteerName = this.zydname
        } else {
          queryObj.volunteerName = ''
        }
        if(this.userInfo.userRole != '2'&&this.userInfo.userRole != '3'){
          _this.pageSize = 0;
        }
        this.$req.queryAllByLimit("volunteerTable", {
          pageSize: _this.pageSize,
          pageNum: _this.pageNum,
          queryObj: queryObj
        }).then(function(response) {
          _this.data = response.data
          _this.total = response.total;
          _this.$utils.setlocalStorage("zydNum", response.total)
          _this.$refs.leftmenu.getData()
        })
      },
      getUserList() {
        let _this = this;
        this.$req.queryAllById({}).then(function(response) {
          _this.userList = response.data
        })
      },
      batchDelet() {
        this.toastflag = false;
        let _this = this;
        this.$req.batchDelete("volunteerTable", {
          id: this.data[this.index].volunteerId
        }).then(function(response) {
          if (response.status == "0") {
            _this.data.splice(_this.index, 1);
            _this.$utils.setlocalStorage("zydNum", _this.data.length)
            _this.$refs.leftmenu.getData()
          }
        })
      },

      quxiao() {
        this.show = false;
        this.vid = "";
        this.vName = "";
      },
      quit() {
        if (this.vName == null || this.vName == "") {
          this.error = "请输入新名称"
          return;
        }

        let _this = this;
        this.$req.update("volunteerTable", {
          volunteerId: this.vid,
          volunteerName: this.vName
        }).then(function(response) {
          if (response.status == "0") {
            _this.$message.success({
              message: "修改成功"
            });
            _this.show = false;
            _this.vid = "";
            _this.vName = "";
            _this.getData();

          }
        })
      },
      updateName(vid) {
        this.show = true;
        this.vid = vid;

      }
    }
  }
</script>

<style scoped>
  /* 测试三个按钮 */
  .chesak {
    display: flex;
    justify-content: space-around;
  }


  /* 测试三个按钮 */
  .zhiyuanList dl {
    margin-top: 0;
    margin-bottom: 5px;
    margin-top: 5px;
  }


  /* 退出登录 */
  .tuichuden {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.8);
  }

  .annou {
    display: flex;
    flex-direction: column;
    width: 380px;
    height: 229px;
    background: rgba(255, 255, 255, 1);
    opacity: 1;
    border-radius: 20px;
    padding: 0 21px;
    box-sizing: border-box;
  }

  .annou h1 {
    width: 100%;
    height: 48px;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #29A7E1;
    opacity: 1;
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }

  .annou p {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
    flex: 1;
  }

  .annou dl {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .annou dl dt {
    cursor: pointer;
    width: 140px;
    height: 46px;
    background: rgba(200, 200, 200, 1);
    opacity: 1;
    border-radius: 23px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .annou dl dd {
    cursor: pointer;
    width: 140px;
    height: 46px;
    background: linear-gradient(129deg, #F53824 0%, #F44F25 61%, #F45D26 100%);
    box-shadow: 0px 0px 10px #F53824;
    opacity: 1;
    border-radius: 24px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .beijngsd {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100px;
    margin-top: 70px;
    background: url(../../assets/gerenzhongxin/geren21.png)no-repeat;
    background-size: 100% 100%;
    font-size: 28px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
  }

  .beijngsd span {
    display: flex;
    width: 44px;
    height: 2px;
    opacity: 0.48;
    border-radius: 1px;
    background-color: #FFFFFF;
  }

  .beijngsd span:nth-of-type(1) {
    margin-right: 14px;
  }

  .beijngsd span:nth-of-type(2) {
    margin-left: 14px;
  }

  .centen {
    width: 1280px;
    margin: 0 auto;
  }

  .manpin {
    width: 100%;
    height: auto;
    padding: 40px 0;
    box-sizing: border-box;
    background: #ebeef5d6;
  }

  .main {
    padding-bottom: 40px;
    display: flex;
    justify-content: space-between;
  }

  .main_l {
    background: rgba(251, 251, 251, 1);
    width: 210px;
  }

  .topxiang {
    width: 100%;
    height: 194px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 1);
    border-radius: 5px;
    margin-bottom: 30px;
  }

  .topxiang img {
    width: 102.73px;
    height: 102.73px;
    margin-bottom: 20px;
  }

  .topxiang span {
    width: 144px;
    height: 22px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    opacity: 1;
  }

  .jibenxinxi {
    width: 290px;
    height: 700px;
    background: rgba(255, 255, 255, 1);
    opacity: 1;
    border-radius: 5px;
  }

  .jibenxinxi figure {
    width: 100%;
    height: 60px;
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .jibenxinxi figure img {
    height: 44px;
    margin-left: 22px;
  }

  .jibenxinxi figure figcaption {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
    margin-left: 10px;
  }

  .beijngsdtu {
    background: url(../../assets/gerenzhongxin/geren26.png)no-repeat;
    background-size: 100% 100%;
  }

  .texts {
    color: #F53824 !important;
  }

  .xiaoxi {
    margin-left: 10px;
    background: url(../../assets/gerenzhongxin/geren18.png)no-repeat;
    background-size: 100% 100%;
    width: 33px;
    height: 23px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }

  .main_r {
    width: 1050px;
    /* height: 878px; */
    background: rgba(255, 255, 255, 1);
    opacity: 1;
    border-radius: 5px;
    padding: 20px;
    box-sizing: border-box;
  }

  .mainr_top {
    width: 100%;
    height: 68px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.10196078431372549);
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
  }

  .mainr_top img {
    width: 7px;
    height: 24px;
    margin-right: 10px;
  }

  .youxinxi {
    padding: 33px 20px 0 20px;
    width: 310px;
    height: 230px;
    background: rgba(253, 251, 247, 1);
    border: 1px solid #FBF5E9;
    opacity: 1;
    border-radius: 5px;
    position: absolute;
    top: 24px;
    right: 20px;
  }

  .mainr_bot {
    width: 100%;
    position: relative;
  }

  .youxinxi label {
    position: absolute;
    top: -14px;
    left: 20px;
    width: 92px;
    height: 28px;
    background: rgba(244, 166, 65, 1);
    opacity: 1;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }

  .youxinxi figure {
    display: flex;
    margin-bottom: 13px;
  }

  .youxinxi figure img {
    margin-right: 4px;
    width: 18px;
    height: 20px;
  }

  .youxinxi figure figcaption {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #5A4F40;
  }

  .form {
    width: auto;
    height: auto;
    display: flex;
    flex-direction: column;
    margin-top: 30px;
    margin-left: 40px;
  }

  .form li {
    width: auto;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    position: relative;
  }

  .form li label {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    width: 80px;
    text-align: right;
  }

  .form li i {
    color: #F53824;
    margin: 0 5px;
  }

  .form li input {
    width: 372px;
    height: 40px;
    background: rgba(255, 255, 255, 0.39);
    border: 1px solid #E0E0E0;
    opacity: 1;
    border-radius: 5px;
    padding: 0 10px;
    box-sizing: border-box;

  }

  .duanxin {
    border: none;
    position: absolute;
    top: 5px;
    left: 240px;
    width: 120px;
    height: 30px;
    background: linear-gradient(180deg, #F53824 0%, #F45D26 100%);
    opacity: 1;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }

  .shoujiinp {
    width: auto;
    display: flex;
    position: relative;
  }

  .form li {
    position: static;
  }

  /* .form li .shoujiinp input{width: auto;} */
  .form li .shoujiinp span {
    margin-top: 5px;
  }

  .form li span {
    margin-left: 5px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #F53824;
    opacity: 1;
  }

  .inps {
    width: 118px;
    height: 40px;
  }

  .inps:nth-of-type(1) {
    margin-right: 9px;
  }

  .inps:nth-of-type(2) {
    margin-right: 9px;
  }

  .inpda {
    width: 372px;
    height: 40px;
    background: rgba(255, 255, 255, 0.39);
    opacity: 1;
  }

  .baochuan {
    border: none;
    margin-left: 115px;
    margin-top: 20px;
    width: 140px;
    height: 46px;
    background: linear-gradient(92deg, #F53824 0%, #F45D26 100%);
    opacity: 1;
    border-radius: 23px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }


  .sousuo {
    width: 100px;
    background-color: #f00;
    color: #fff;
    /* margin-left: 20px; */
    font-size: 18px;
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
    font-weight: 800;
    height: 40px;
    text-align: center;
    line-height: 36px;
  }

  .sousuo img {
    padding: 15px 9px 15px;
    background: red;
    width: 50px;
    height: 50px;
    border-radius: 6px;
  }

  .serachkuang .sinput {
    border: none;
    width: 300px;
    height: 40px;
    background: #fff;
    opacity: 1;
    /* border-radius: 6px; */
    /* margin-left: 15px; */
    border: 1px solid #ddd;
    padding-left: 15px;
    font-size: 14px;
  }

  .sinput::placeholder {
    font-size: 14px;
  }

  ::-webkit-input-placeholder {
    color: #999999;
  }

  .serachkuang {
    display: flex;
    height: 100%;
    text-align: center;
    align-items: center;
    justify-content: center;
  }

  .searchsel {
    width: 120px;
  }


  @media (min-width:750px) {
    .mainr_bot2 {
      display: none;
    }
  }

  @media (max-width:750px) {
    .mainr_bot {
      display: none;
    }

    .beijngsd {
      height: 70px;
      font-size: 24px;
    }

    .main {
      flex-direction: column;
    }

    .main_l {
      width: 100%;
    }

    .jibenxinxi::-webkit-scrollbar {
      display: none;
    }

    .manpin {
      padding: 20px 0;
    }

    .topxiang {
      flex-direction: row;
      width: 100%;
      height: auto;
      justify-content: revert;
      margin-bottom: 15px;
    }

    .topxiang span {
      margin-left: 20px;
    }

    .topxiang img {
      margin: 0;
      height: 60px;
      width: 60px;
    }

    .jibenxinxi {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: row;
      overflow-y: hidden;
      overflow: auto;
      background: whitesmoke;
    }

    .jibenxinxi figure {
      flex-shrink: 0;
      width: auto;
      margin: 0 5px;
    }

    .beijngsdtu {
      /* background: url(../../assets/gerenzhongxin/sj_geren26.png)no-repeat; */
      background: none;
      /* background-size: 100% 100%; */
      border-bottom: 1px solid #F53824;
    }

    .jibenxinxi figure img {
      margin-left: 0;
    }

    .youxinxi2 {
      padding: 33px 20px 0 20px;
      width: 100%;
      height: 230px;
      background: rgba(253, 251, 247, 1);
      border: 1px solid #FBF5E9;
      opacity: 1;
      border-radius: 5px;
      position: relative;
    }

    .mainr_bot2 {
      width: 100%;
      margin-top: 20px;
      /* position: relative; */
    }

    .youxinxi2 label {
      position: absolute;
      top: -14px;
      left: 20px;
      width: 92px;
      height: 28px;
      background: rgba(244, 166, 65, 1);
      opacity: 1;
      border-radius: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
    }

    .youxinxi2 figure {
      display: flex;
      margin-bottom: 13px;
    }

    .youxinxi2 figure img {
      margin-right: 4px;
      width: 18px;
      height: 20px;
    }

    .youxinxi2 figure figcaption {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #5A4F40;
    }

    .main_r {
      width: 100%;
      display: flex;
      flex-direction: column;
    }


    .form {
      margin-left: 0;
    }

    .shoujiinp {
      flex: 1;
      display: flex;
      flex-direction: column;
      position: relative;
    }

    .form li {
      position: static;
    }

    .form li .shoujiinp input {
      width: auto;
    }

    .form li .shoujiinp span {
      margin-top: 5px;
    }

    .form li label {
      flex-shrink: 0;
    }

    .duanxin {
      right: 10px;
      left: auto;
      top: 5px;
      width: 85px;
      border-radius: 5px;
      font-size: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/mine/i_wdzhiyuan.vue